import React from 'react'
import SwoodleLogo from '../../../../Assets/Icons/SwoodleUpdatedLogo.svg'

const Header = () => {
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className='w-full fixed left-0 top-0 z-40 pl-[2%] py-[10px] flex items-center shadow-none transition-all duration-200'
      style={{
        backgroundColor: isScrolled ? 'rgba(0, 32, 66, 0.75)' : '#002042',
        backdropFilter: isScrolled ? 'saturate(120%) blur(2px)' : 'none',
      }}
    >
      <a href="https://swoodle.com.au/" target="_blank" rel="noopener noreferrer">
        <img className='w-[140px] sm:w-[160px] md:w-[180px]' src={SwoodleLogo} alt="Swoodle" />
      </a>
    </div>
  )
}

export default Header;